import { Box, Button, Table, Text, colors } from '@factorialco/deprecated-design-system'
import { FinanceFileFragment, FinanceInvoiceFileFragment } from 'generated/resources/graphql'

import DocumentType from 'modules/core/components/DocumentType'
import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'

interface DocumentRowProps {
  file: FinanceFileFragment | FinanceInvoiceFileFragment
  onDownload: (url: string, fileName: string) => void
  onClick?: (file: FinanceFileFragment | FinanceInvoiceFileFragment) => void
  selected?: boolean
}

export const DocumentRow: React.FC<DocumentRowProps> = ({
  file,
  onClick,
  onDownload,
  selected,
}) => {
  return (
    <Table.Row clickable={!!onClick} onClick={() => onClick?.(file)}>
      <Table.Cell
        style={{
          borderLeft: selected ? `4px solid ${colors.viridian1000}` : 'none',
          paddingLeft: selected ? '20px' : '24px',
        }}
      >
        <DocumentType mimetype={file.contentType} />
      </Table.Cell>
      <Table.Cell paddingX="s0" style={{ width: '100%' }}>
        <Box width="full" overflowX="hidden" alignItems="flexStart">
          <Text.Normal weight="medium" ellipsis lineClamp={2}>
            {file.filename}
          </Text.Normal>
          <Box paddingTop="s4">
            <Text.Normal size="200" color="grey600">
              {dateBackendDateTimeToUI(file.createdAt)}
            </Text.Normal>
          </Box>
        </Box>
      </Table.Cell>
      <Table.Cell>
        <Box flexDirection="row" gap="s8">
          <Button
            type="secondary"
            iconName="download"
            onClick={() => {
              onDownload(file.url, file.filename)
            }}
          />
        </Box>
      </Table.Cell>
    </Table.Row>
  )
}
